import React from "react";

const ACCENTS = {
  blue: "border-white/20 bg-white/10 text-white",

  emerald:
    "border-emerald-300/30 bg-emerald-300/10 text-emerald-50",

  amber:
    "border-amber-300/30 bg-amber-300/10 text-amber-50",

  indigo:
    "border-indigo-300/30 bg-indigo-300/10 text-indigo-50",
};

export default function CompactStat({
  icon,
  label,
  value,
  accent = "blue",
  loading = false,
}) {
  return (
    <div
      className={`rounded-2xl border p-3 backdrop-blur-sm ${
        ACCENTS[accent] ?? ACCENTS.blue
      }`}
    >
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/15 text-base">
          {icon}
        </span>

        <span className="min-w-0">
          <span className="block truncate text-[10px] font-semibold uppercase tracking-[0.15em] text-white/70">
            {label}
          </span>

          <span className="mt-0.5 block text-xl font-bold text-white">
            {loading ? "…" : value}
          </span>
        </span>
      </div>
    </div>
  );
}